<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['employee']+language['column.jobNumber']">
              <a-input :placeholder="language['common.pleaseInput']+language['employee']+language['column.jobNumber']" v-model="queryParam.user"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['employee']+language['portal.personalName']">
              <a-input :placeholder="language['common.pleaseInput']+language['employee']+language['portal.personalName']" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['depart.management.artificialPerson']">
              <a-input :placeholder="language['common.pleaseInput']+language['depart.management.artificialPerson']" v-model="queryParam.company"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['gift_user_app']">
              <a-select  :placeholder="language['column.pleaseChoose']+language['gift_user_app']"  v-model='queryParam.app' :disabled='appLimit.flag' @change='changeApp' >
                <a-select-option v-for="(value, key) in appOptions" :key="key" :value="key"  >
                  {{ value }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>



          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['gift_user_state']">
              <j-dict-select-tag v-model="queryParam.effective" :title="language['gift_user_state']" dictCode="gift_user_status" :placeholder="language['column.pleaseChoose']+language['gift_user_state']"/>
<!--              <a-input placeholder="请选择状态" v-model="queryParam.user"></a-input>-->
            </a-form-item>
          </a-col>


          <a-col :xl="8" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" v-has="'gift:user:add'" icon="plus">{{language['common.insertButton']}}</a-button>
      <a-button type="primary" icon="download" v-has="'gift:user:export'" @click="handleExportXls('app_user')">{{language['common.exportButton']}}</a-button>

      <a-button type="primary" icon="download" v-has="'gift:user:import'" @click="downloadTemplate()">{{language['common.import.template.download']}}</a-button>

      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import" v-has="'gift:user:import'" >{{language['common.importButton']}}</a-button>
      </a-upload>
<!--      <a-button type="primary" @click="cleanCache(record)">{{language['gift.clean.cache']}}</a-button>-->
      <a-dropdown v-if="selectedRowKeys.length > 0" v-has="'gift:user:delete'">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{language['common.delete']}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px" v-has="'gift:user:delete'"> {{language['common.batchAction']}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :width='1800'
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="false"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="switchSlot" slot-scope="effective, record, idx">
             <a-switch :checked='effective'  @click='changeEffective(effective,record, idx)' />
        </span>

        <template slot='content'  slot-scope='text'>
          <div class='slot-content' :title='text'>
            <a-span >{{text}}</a-span>
          </div>
        </template>

        <template slot='hideIdCard' slot-scope='text'>
          <div class='slot-content' :title='text'>
            <a-span>{{ hideIdCard(text) }}</a-span>
          </div>
        </template>

        <template slot='app' slot-scope='text'>
          <div class='slot-content' :title='appOptions[text]' >
            <a-span >{{appOptions[text]}}</a-span>
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">編輯</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">詳情</a>
              </a-menu-item>
<!--               <a-menu-item>
                <a @click="cleanCache(record)">清理缓存</a>
              </a-menu-item>-->
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <app-user-modal ref="modalForm" @ok="modalFormOk" :app-options='appOptions'></app-user-modal>
  </a-card>
</template>

<script>

  import '@assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import AppUserModal from './modules/AppUserModal'
  import { downFile, getAction, postAction } from '@api/manage'
  import DictList from '@views/system/DictList'

  export default {
    name: 'AppUserList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      DictList,
      AppUserModal
    },
    data () {
      const language = this.$store.getters.language;
      return {
        disableMixinCreated: true,
        description: '白名单用户管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            maxWidth:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title: language['employee']+language['column.jobNumber'],
            align:"center",
            width: 120,
            scopedSlots: { customRender: 'content' },
            dataIndex: 'user'
          },
          {
            title:language['employee']+language['portal.personalName'],
            align:"center",
            width: 150,
            scopedSlots: { customRender: 'content' },
            dataIndex: 'name'
          },
          {
            title: language['gift.user.id.card.number'],
            align:"center",
            width: 150,
            scopedSlots: { customRender: 'hideIdCard' },
            dataIndex: 'idCardNumber',
          },
          {
            title:language['gift_user_app'],
            align:"center",
            width: 150,
            scopedSlots: { customRender: 'app' },
            dataIndex: 'app'
          },
          {
            title:language['gift.user.paying.legal.person'],
            align:"center",
            width: 150,
            scopedSlots: { customRender: 'content' },
            dataIndex: 'payingLegalPerson'
          },
          {
            title:language['depart.management.artificialPerson'],
            align:"center",
            width: 150,
            scopedSlots: { customRender: 'content' },
            dataIndex: 'company'
          },
          {
            title:language['gift_user_start_point'],
            align:"center",
            width: 80,
            dataIndex: 'points'
          },
          {
            title:language['gift_user_used_point'],
            align:"center",
            width: 80,
            dataIndex: 'usedPoints'
          },
          {
            title:language['gift_user_remain_point'],
            align:"center",
            width: 80,
            ellipsis:true,
            dataIndex: 'balancePoints'
          },
          {
            title:language['gift_user_start_time'],
            align:"center",
            width: 180,
            ellipsis:true,
            dataIndex: 'appStartTime',
          },
          {
            title:language['gift_user_deadline'],
            align:"center",
            width: 180,
            ellipsis:true,
            dataIndex: 'endTime',
          },
          {
            title:language['gift_user_agree'],
            align:"center",
            dataIndex: 'agree_dictText'
          },
          {
            title:language['gift_user_state'],
            align:"center",
            dataIndex: 'effective',
            scopedSlots: { customRender: 'switchSlot' },
          },
         /* {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }*/
        ],
        url: {
          list: "/gift/user/appusers",
          delete: "/gift/user/appuser",
          deleteBatch: "/gift/user/appuser/batch",
          exportXlsUrl: "/gift/user/export-xls",
          importExcelUrl: "gift/user/import-excel",
          importTemplate: "gift/user/import-template",
          turnEffective: "/gift/user/turnEffective",
          getInitData: "/gift/user/initData",
          checkAppLimit: '/gift/app/checkAppLimit/code',
          clearRedis: '/gift/user/clear'
        },
        dictOptions:{},
        superFieldList:[],
        appCode:'',
        appOptions:[],
        appLimit:{
          flag: false,
          value: undefined
        }
      }
    },
    created() {
       this.checkAppLimit();
       this.getInitData();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      changeApp(val){
        this.queryParam.app = val;
        this.$forceUpdate();
      },
      async checkAppLimit(){
        await getAction(this.url.checkAppLimit).then(res=>{
          if (res.success){
            this.appLimit.flag = true;
            this.queryParam.app = res.result;
            this.appLimit.value = res.result;
          }
        })
        this.loadData(1);
      },
      getInitData(){
        getAction(this.url.getInitData).then(res=>{
          if (res.success){
            this.appOptions = res.result.app;
            this.$forceUpdate();
          }
        })
      },
      searchReset(){
        this.queryParam = {};
        this.queryParam.app = this.appLimit.value;
        this.appCode = '';
        this.loadData(1);
      },
      changeEffective(checked,record, idx){
        postAction(this.url.turnEffective,record).then((res)=>{
          if (res.success){
            // this.loadData();
            if (this.dataSource[idx]) this.dataSource[idx].effective = checked === 0 ? 1 : 0;
            return true;
          }else {
            this.$message.error(res.message);
            return false;
          }
        })
      },
      downloadTemplate(){
        let fileName = "白名單導入模板"
        downFile(this.url.importTemplate).then((data)=>{
          if (!data) {
            this.$message.warning(this.language['common.fileDowloadError'])
            return
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
          }else{
            let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName+'.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        })
      },
      /*cleanCache(){
        getAction(this.url.clearRedis).then(res=>{
          console.log(res,"ressss");
           if (res.success){
             this.$message.success("清理成功！");
           }else {
             this.$message.error("操作失敗！");
           }
        })

      },*/
      hideIdCard(idCard) {
        if (idCard && idCard.length >= 8) {
          // 将身份证号码分为前四位、中间四位、后四位
          let prefix = idCard.substring(0, 4);
          let middle = "****";
          let suffix = idCard.substring(idCard.length - 4);
          // 拼接隐藏后的身份证号码
          return prefix + middle + suffix;
        } else {
          return idCard;
        }
      }

  }
}
</script>
<style scoped>
  @import '~@assets/less/common.less';
  .slot-content{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 150px;
  }
</style>
